<template>
  <div>
    <div class="form-group theme-payment-page-form-item">
      <i
        v-if="!loading"
        class="fa fa-angle-down"></i>
      <i
        v-if="loading"
        class="fa fa-spinner fa-spin price-fare-rules size-16"></i>
      <select
        @input="$emit('update:traveler', $event.target.value)"
        :value="traveler"
        :class="{ 'alert-danger': (submitted && !traveler || traveler === 'null') || alert }"
        class="form-control border-blue"
        name="traveler">
        <option v-if="alert" value="">{{ alert }}</option>
        <option v-if="!alert" :value="null">
          <template v-if="!travelers.length">Não existem viajantes</template>
          <template v-else>Selecione o viajante*</template>
        </option>
        <option
          v-for="traveler in travelers"
          :key="traveler.id"
          :value="traveler.id">{{ traveler.name }}</option>
      </select>
    </div>
    <div class="mt-5">
      <span class="size-12 weight-normal">* Obrigatório selecionar o viajante</span>
      <traveler-dialog class="pull-right"></traveler-dialog>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import TravelerDialog from '@/components/dialogs/TravelerDialog'

export default {
  components: { TravelerDialog },
  props: [
    'traveler',
    'submitted',
    'item'
  ],
  data () {
    return {
      alert: null
    }
  },
  mounted () {
    this.alert = null

    this.getTravelersParent()
      .then(this.setTravelers)
      .catch(() => {
        this.alert = 'Não foi possível buscar os viajantes'
      })
  },
  computed: {
    ...mapState(['user']),
    ...mapState('travelers', ['loading', 'results']),
    ...mapGetters('travelers', ['travelersCanBooking']),
    travelers () {
      return (this.item) ? this.travelersCanBooking(this.item) : this.results
    }
  },
  watch: {
    user (data) {
      if (data.completedRegister) {
        this.getTravelersParent()
      }
    }
  },
  methods: {
    ...mapActions('travelers', ['getTravelersParent'])
  }
};
</script>
